/**
 * UranIA PA — Alt identity button CIE/CNS (US-010).
 *
 * Bottone secondario Bootstrap Italia per CIE (Carta d'Identità Elettronica,
 * US-005) e CNS (Carta Nazionale dei Servizi, US-006). UI singolo bottone,
 * niente dropdown — CIE è un unico provider istituzionale MinInt, CNS è
 * legato alla smart card fisica dell'utente.
 *
 * NB: `flavour='cns'` indica all'utente Auditor che l'autenticazione passa
 * dalla smart card via mTLS edge Traefik (US-006); il bottone avvia comunque
 * la signinRedirect contro Keycloak.
 */

import { useTranslation } from 'react-i18next';
import type { JSX } from 'react';

export type AltIdentityFlavour = 'cie' | 'cns';

export interface AltIdentityButtonProps {
  readonly flavour: AltIdentityFlavour;
  readonly onClick: () => void;
  readonly disabled?: boolean;
}

const LABEL_KEY: Record<AltIdentityFlavour, 'auth.login_with_cie' | 'auth.login_with_cns'> = {
  cie: 'auth.login_with_cie',
  cns: 'auth.login_with_cns',
};

const INTRO_KEY: Record<AltIdentityFlavour, 'login.cie_intro' | 'login.cns_intro'> = {
  cie: 'login.cie_intro',
  cns: 'login.cns_intro',
};

export function AltIdentityButton({
  flavour,
  onClick,
  disabled = false,
}: AltIdentityButtonProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className={`urania-alt-identity urania-alt-identity--${flavour}`}>
      <button
        type="button"
        className="btn btn-outline-primary urania-alt-identity__button"
        data-testid={`${flavour}-button`}
        disabled={disabled}
        onClick={onClick}
      >
        <span className="urania-alt-identity__brand" aria-hidden="true">
          {flavour === 'cie' ? 'CIE' : 'CNS'}
        </span>
        <span className="urania-alt-identity__label">{t(LABEL_KEY[flavour])}</span>
      </button>
      <p className="urania-alt-identity__intro small text-muted mb-0">{t(INTRO_KEY[flavour])}</p>
    </div>
  );
}
